import { CaseStudy } from "./sections/our.cases";

export interface CaseStudy {
    path: string;
    logo: string;
    descriptionTextIDs: string;
    solutionsIDs: string[];
}

export const CaseStudies: CaseStudy[] = [
    {
        path: `case-jnj`,
        logo: `${process.env.PUBLIC_URL}/index/jj.svg`,
        descriptionTextIDs: "index_page.our_cases_section.case-jnj.description",
        solutionsIDs: [
            "index_page.our_cases_section.case-jnj.solution_1",
            "index_page.our_cases_section.case-jnj.solution_2",
            "index_page.our_cases_section.case-jnj.solution_3",
        ],
    },
    {
        path: `case-av`,
        logo: `${process.env.PUBLIC_URL}/index/av.svg`,
        descriptionTextIDs: "index_page.our_cases_section.case-av.description",
        solutionsIDs: [
            "index_page.our_cases_section.case-av.solution_1",
            "index_page.our_cases_section.case-av.solution_2",
            "index_page.our_cases_section.case-av.solution_3",
            "index_page.our_cases_section.case-av.solution_4",
            "index_page.our_cases_section.case-av.solution_5",
        ],
    },
    {
        path: `ard`,
        logo: `${process.env.PUBLIC_URL}/index/ard.svg`,
        descriptionTextIDs: "index_page.our_cases_section.case-dd.description",
        solutionsIDs: [
            "index_page.our_cases_section.case-dd.solution_1",
            "index_page.our_cases_section.case-dd.solution_2",
            "index_page.our_cases_section.case-dd.solution_3",
        ],
    },
    {
        path: `aip`,
        logo: `${process.env.PUBLIC_URL}/index/aip.svg`,
        descriptionTextIDs: "index_page.our_cases_section.aip.description",
        solutionsIDs: [
            "index_page.our_cases_section.aip.solution_1",
            "index_page.our_cases_section.aip.solution_2",
            "index_page.our_cases_section.aip.solution_3",
        ],
    },
    {
        path: `dona`,
        logo: `${process.env.PUBLIC_URL}/index/dona.svg`,
        descriptionTextIDs: "index_page.our_cases_section.dona.description",
        solutionsIDs: [
            "index_page.our_cases_section.dona.solution_0",
            "index_page.our_cases_section.dona.solution_1",
            "index_page.our_cases_section.dona.solution_2",
            "index_page.our_cases_section.dona.solution_3",
        ],
    },
];
